<template>
    <div class="container third">
        <div class="row">
            <div class="col-8">
                <div class="headline h2">
                    <span>Deine Qualifikation</span>
                </div>

                <div class="row">
                    <div class="input-group col-6">
                        <label v-for="(graduation, graduationIndex) in graduations" class="radio" v-bind:key="graduationIndex" v-bind:class="{ 'invalid': errors.first('graduation') }">
                            <input type="radio" :name="'graduation'" :value="graduation.name" v-model="selectedGraduations"
                                   v-validate="'required|minLength:1'" data-vv-as="Schulabschluss" > <span>{{ graduation.name }}</span>
                        </label>
                        <!--<span class="text-danger">{{ errors.first('graduation') }}</span>-->
                    </div>
                    <div class="input-group col-6">
                        <input v-model="cut" placeholder="Durschnittsnote" v-validate="'required'">
                    </div>

                </div>

                <div class="row border-top">
                    <div class="input-group col-6">
                        <label v-for="(experience, experienceIndex) in experiences" class="checkbox" v-bind:key="experienceIndex">
                            <input type="checkbox" :name="'experience'" :value="experience.name" v-model="selectedExperiences"
                                   v-validate="" data-vv-as="Erfahrung" > <span>{{ experience.name }}</span>
                        </label>
                    </div>
                    <div class="input-group col-6">
                        <textarea v-model="experienceComment" placeholder="Informationen zu früheren Nachhilfeverhältnissen, weiteren Qualifikationen etc." v-validate="" rows="10"></textarea>

                    </div>

                </div>
            </div>
            <div class="col-4 icon-master">
                <i class="fa fa-scroll"></i>
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: 'thirdStep',
        components: {
        },

        data: function () {
            return {
                cut: '',
                experienceComment: '',
                selectedGraduations: [],
                selectedExperiences: [],

                maxDateTime: new Date().toISOString(),
                graduations: [
                    {
                        name: 'Allgemeine Hochschulreife'
                    },
                    {
                        name: 'Fachabitur'
                    }
                ],
                experiences: [
                    {
                        name: 'Ich habe Erfahrung im Nachhilfegeben.'
                    }
                ]
            }
        },

        mounted() {

        },

        methods: {
            nextPage() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Success
                        this.$emit('openNextPage', this);
                        return;
                    }
                    if (!result) {
                        // Error
                        this.showErrors = true;
                        console.log(this);
                    }
                });
            }
        }
    }
</script>

<style>
    .third .checkbox-split label {
        width: 48.5%;
    }
</style>